<template>
  <div>
    <div class='pt-2 altura-250 tab-ficha'>
      <div v-if='personajornada.length > 0'>
        <div class='centrado'>
          <select class='form-control col-md-4' v-model='jornadaSelectedId'>
            <option disabled value='0' selected='selected'>Seleccione jornada</option>
            <option v-for='jornadaItem in personajornada' :key='jornadaItem.jornada.msjornadaid' :value='jornadaItem.jornada.msjornadaid'>
              {{ jornadaItem.jornada.msjornadatipostr }}
              <!-- {{ jornadaItem.mspersonajornadafechainicio !== '' && jornadaItem.mspersonajornadafechafin !== '' ? ' (' + jornadaItem.mspersonajornadafechainicio + ' / ' + jornadaItem.mspersonajornadafechafin + ')' : '' }} -->
            </option>
          </select>
        </div>
        <div v-if='horariodia.length > 0'>
          <!-- Titulo y descripcion de la jornada -->
          <div class='pt-2 col-underline' v-if='jornadaSelected'>
            <label size='sm'>
              {{ jornadaSelected.msjornadatipostr }} {{ jornadaFechas }}
            </label>
            <br>
            <small>
              {{ jornadaSelected.msjornadadesc }}
            </small>
          </div>
          <!-- Horario de la jornada -->
          <table width='100%'>
            <tr>
              <th scope='row' width='20%'>{{ tableTitulos.dia }}</th>
              <th scope='row' width='40%'>{{ tableTitulos.horario }}</th>
              <th scope='row' width='40%'>{{ tableTitulos.total }}</th>
            </tr>
            <tr
              v-for='horariodiaItem in horariodia'
              :key='horariodiaItem.mshorariodiaid'
              :class='{ par: horariodiaItem.diaPar }'
            >
              <td width='20%'>
                <small>
                  {{ diasArray[horariodiaItem.mshorariodiadiasemana - 1] }}
                </small>
              </td>
              <td width='40%'>
                <small>
                  {{ horariodiaItem.mshorariodiainicio1 }} &#8594; {{ horariodiaItem.mshorariodiafin1 }} {{ horariodiaItem.mshorariodiainicio2 ? ' / ' + horariodiaItem.mshorariodiainicio2 + ' &#8594; ' + horariodiaItem.mshorariodiafin2 : '' }}
                </small>
              </td>
              <td width='40%'>
                <small>
                  <b>{{ horariodiaItem.total }}</b>
                </small>
              </td>
            </tr>
          </table>
          <!-- FIN. Horario de la jornada -->
        </div>
      </div>
      <div class='centrado pt-4' v-else>
        {{ tableTitulos.sinregistros }}
      </div>
    </div>
  </div>
</template>
<script>
import { JornadaApiService } from '@/api/JornadaApiService'
import { HorariodiaApiService } from '@/api/HorariodiaApiService'
import { Util } from '@/api/Util'

const moment = require('moment')
const util = new Util()
const jornadaApiService = new JornadaApiService()
const horariodiaApiService = new HorariodiaApiService()

export default {
  data () {
    return {
      personajornada: [],
      horariodia: [],
      jornadaSelectedId: 0,
      jornadaSelected: Object,
      dateContext: moment(),
      diasArray: [
        this.$t('lang.calendario.lun'),
        this.$t('lang.calendario.mar'),
        this.$t('lang.calendario.mie'),
        this.$t('lang.calendario.jue'),
        this.$t('lang.calendario.vie'),
        this.$t('lang.calendario.sab'),
        this.$t('lang.calendario.dom')
      ],
      tableTitulos: {
        dia: this.$t('lang.comun.dia'),
        horario: this.$t('lang.comun.horario'),
        total: this.$t('lang.comun.total'),
        sinregistros: this.$t('lang.comun.sinregistros')
      },
      msj: {
        desde: this.$t('lang.comun.desde'),
        hasta: this.$t('lang.comun.hasta')
      },
      jornadaFechas: ''
    }
  },
  props: {
    personaParam: Object,
    tabSeleccionado: Number
  },
  watch: {
    personaParam: {
      handler (n, o) {
        if (n.mspersonaid !== o.mspersonaid) {
          this.getPersonajornadaByAnhoPersonaUid()
        }
      },
      deep: true
    },
    jornadaSelectedId: {
      handler (n, o) {
        if (n !== o) {
          this.getHorariodiaByJornadaId()
          this.getSelectedJornada()
        }
      },
      deep: true
    }
  },
  mounted () {
    this.reset()
  },
  methods: {
    reset () {
      this.getPersonajornadaByAnhoPersonaUid()
    },
    getJornadaByAnhoAndPersonaId () {
      if (this.personaParam) {
        jornadaApiService.getJornadaByAnhoAndPersonaId(this.dateContext.format('YYYY'), this.personaParam.mspersonaid)
          .then(data => {
            util.mostrarEnConsola('PersonasTabJornada - getJornadaByAnhoAndPersonaId', data.length, 'OK')
            this.jornada = data
          })
          .catch(error => {
            util.mostrarEnConsola('PersonasTabJornada - getJornadaByAnhoAndPersonaId', error, 'ERROR')
          })
      }
    },
    getSelectedJornada () {
      if (this.jornadaSelectedId !== 0 && this.personajornada.length > 0) {
        for (let i = 0; i < this.personajornada.length; i++) {
          const personajornadaItem = this.personajornada[i].jornada
          if (personajornadaItem.msjornadaid === this.jornadaSelectedId) {
            this.jornadaSelected = personajornadaItem
            // Modificamos las fechas de la jornada
            this.jornadaFechas = ''
            if (this.personajornada[i].mspersonajornadafechainicio !== '' && this.personajornada[i].mspersonajornadafechafin !== '') {
              this.jornadaFechas += '(' + this.msj.desde + ' ' + this.personajornada[i].mspersonajornadafechainicio + ' ' + this.msj.hasta + ' ' + this.personajornada[i].mspersonajornadafechafin + ')'
            }
            break
          }
        }
      }
    },
    getHorariodiaByJornadaId () {
      if (this.jornadaSelectedId !== 0) {
        // horariodiaApiService.findAllHorariodia({ jornada: { msjornadaid: this.jornadaSelectedId } })
        horariodiaApiService.findAllHorariodia({ jornada: { msjornadaid: this.jornadaSelectedId } })
          .then(data => {
            util.mostrarEnConsola('PersonasTabJornada - getHorariodiaByJornadaId', data.length, 'OK')
            // Recorremos el array, sumamos totales y ponemos par
            let count = 0
            for (let i = 0; i < data.length; i++) {
              let horariodiaItem = data[i]
              let duracion = 0
              if (horariodiaItem.mshorariodiafin1 && horariodiaItem.mshorariodiainicio1) {
                duracion += moment.duration(moment(horariodiaItem.mshorariodiafin1, 'hh:mm').diff(moment(horariodiaItem.mshorariodiainicio1, 'hh:mm')))
              }
              if (horariodiaItem.mshorariodiafin2 && horariodiaItem.mshorariodiainicio2) {
                duracion += moment.duration(moment(horariodiaItem.mshorariodiafin2, 'hh:mm').diff(moment(horariodiaItem.mshorariodiainicio2, 'hh:mm')))
              }
              horariodiaItem.total = util.convertirMilisegundoAHoras(duracion, 1)
              if (count === 0) {
                horariodiaItem.diaPar = true
                count++
              } else {
                horariodiaItem.diaPar = false
                count = 0
              }
            }
            this.horariodia = data
          })
          .catch(error => {
            util.mostrarEnConsola('PersonasTabJornada - getHorariodiaByJornadaId', error, 'ERROR')
          })
      }
    },
    getPersonajornadaByPersonaUid () {
      if (this.personaParam) {
        jornadaApiService.getPersonajornadaByPersonaUid(this.personaParam.mspersonauid)
          .then(data => {
            util.mostrarEnConsola('PersonasTabJornada - getPersonajornadaByPersonaUid', data.length, 'OK')
            this.personajornada = data
            if (this.personajornada.length > 0) {
              this.jornadaSelectedId = this.personajornada[0].jornada.msjornadaid
            }
          })
          .catch(error => {
            util.mostrarEnConsola('PersonasTabJornada - getPersonajornadaByPersonaUid', error, 'ERROR')
          })
      }
    },
    getPersonajornadaByAnhoPersonaUid () {
      if (this.personaParam) {
        jornadaApiService.getPersonajornadaByAnhoPersonaUid(this.dateContext.format('YYYY'), this.personaParam.mspersonauid)
          .then(data => {
            util.mostrarEnConsola('PersonasTabJornada - getPersonajornadaByAnhoPersonaUid', data.length, 'OK')
            this.personajornada = data
            // Seleccionamos la primera
            if (this.personajornada.length > 0) {
              this.jornadaSelectedId = this.personajornada[0].jornada.msjornadaid
            }
          })
          .catch(error => {
            util.mostrarEnConsola('PersonasTabJornada - getPersonajornadaByAnhoPersonaUid', error, 'ERROR')
          })
      }
    }
  }
}
</script>
